module.exports = __webpack_public_path__ + "static/media/wrong-answer.b33fc6a8.mp3";